import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {AiAssistantService} from "./yz-ai-assistant.service";
import {TokenService} from "../../token/token.service";
import {UserService} from "../../user/user.service";
import {ActivatedRoute} from "@angular/router";
import {ModalRef, ModalService} from "ng-zorro-antd-mobile";

@Component({
  selector: 'yz-ai-assistant',
  templateUrl: './yz-ai-assistant.component.html',
  styleUrls: ['./yz-ai-assistant.component.less']
})
export class YzAiAssistantComponent implements OnInit, OnDestroy {

  aiAssistantShow = false;
  aiAssistantList: Array<AiAssistant> = [];
  selectAi: AiAssistant;

  modalRef: Array<ModalRef> = [];

  // 拖动边界
  @Input() cdkDragBoundary = '';

  // 系统编码
  @Input() systemCode = null;

  constructor(private sanitizer: DomSanitizer,
              private aiAssistantService: AiAssistantService,
              private activatedRoute: ActivatedRoute,
              private tokenService: TokenService,
              private user: UserService,
              private modalService: ModalService) {
  }

  ngOnInit() {
    if (this.tokenService.get().accessToken) {
      this.queryAiAssistant(this.systemCode);
    }
  }

  // 查询我的助手
  async queryAiAssistant(systemCode: string) {
    const userId = await this.compressAndEncodeBase64(this.user.get().userId);
    const userCode = await this.compressAndEncodeBase64(this.user.get().userCode);
    const userToken = await this.compressAndEncodeBase64(this.tokenService.get().accessToken);

    this.aiAssistantService.getAiAssistant(systemCode).subscribe((res: Array<AiAssistant>) => {
      this.aiAssistantList = res.map(item => {
        const url = item.url.replace(/\{gzipBase64UserId\}/g, encodeURIComponent(userId)).replace(/\{gzipBase64UserCode\}/g, encodeURIComponent(userCode)).replace(/\{gzipBase64UserToken\}/g, encodeURIComponent(userToken));
        return {
          safeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(url),
          ...item
        };
      });

      this.selectAi = this.aiAssistantList.length > 0 ? this.aiAssistantList[0] : null;
    });
  }

  // url参数压缩编码方法
  // const text = "apple";
  // const encoded = await compressAndEncodeBase64(text);
  async compressAndEncodeBase64(input) {
    const uint8Array = new TextEncoder().encode(input);
    // @ts-ignore
    const compressedStream = new Response(new Blob([uint8Array]).stream().pipeThrough(new CompressionStream('gzip'))).arrayBuffer();
    const compressedUint8Array = new Uint8Array(await compressedStream);
    return btoa(String.fromCharCode(...compressedUint8Array));
  }


  showOpeartion() {
    const actions = this.aiAssistantList.map((item, index) => {
      return {
        ...item,
        text: item.name,
        onPress: () => {
          this.selectAi = this.aiAssistantList[index];
        }
      };
    });

    const ref: ModalRef = this.modalService.operation(actions);
    this.modalRef.push(ref);
  }

  ngOnDestroy(): void {
    // 将直接销毁对话框
    this.modalRef.forEach((ref) => {
      ref.destroy();
    });
  }
}

export interface AiAssistant {
  id?: string;
  name?: string;
  url?: string;
  safeUrl?: SafeResourceUrl;
}
